import { Alert } from "@mui/material"
import { useEffect, useState } from "react"
import API from "../../services/API/Signature"
import { useParams } from "react-router-dom"
import Loader from "../Tools/Loader"
import Signature from "./Signature"
import Frame from "../Frames/Basic"

export default function Page(){

    const {id} = useParams()

    const [data, setData] = useState(null)

    useEffect(() => {

        API.get(id)
            .then(r => setData(r.data))
            .catch(e => setData(false))

    }, [id])


    return <Frame>        

        {data === null && <Loader />}

        {data === false && 
            <Alert severity='error'>Signature introuvable</Alert>
        }

        {data && 
            <Signature
                data={data}
            />
        }

    </Frame>
}